import { styled } from 'styled-components';

import { UnstyledNativeLink } from '#/components/Link/UnstyledNativeLink';
import {
  colors,
  cssBreakpoints,
  gutterWidth,
  maxWidth,
  transition,
} from '#/theme/theme';

export const ViewOrgPageLayoutHeader = styled.header`
  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-bottom: 16px;
    margin-top: 32px;
  }
`;

export const ViewOrgPageFooterHolder = styled.div`
  background: ${colors.backgroundGrey};
  margin-top: 70px;
  padding: 70px 0;
  text-align: center;
`;

export const ViewOrgPageFooterWrapper = styled.div`
  margin: 0 auto;
  max-width: ${maxWidth[3]}px;
  padding: 0 ${gutterWidth / 2}px;
`;

export const ViewOrgPageLayoutSidebarTitle = styled.div`
  /* block-no-empty */
`;

export const ViewOrgPageSidebarLinkUl = styled.ul`
  appearance: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  list-style: none;

  &:not(:empty) {
    margin-top: 16px;
  }
`;

export const ViewOrgPageSidebarLinkLi = styled.li`
  appearance: none;
`;

export const ViewOrgPageSidebarLink = styled(UnstyledNativeLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  background: ${colors.secondarySkyBlue};
  transition: ${transition};
  transition-property: background;
  color: ${colors.white};

  &:hover,
  &:focus {
    color: ${colors.white};
    background: ${colors.hoverBlue};
  }
`;

export const ViewOrgPageSidebarLinkCandid = styled(ViewOrgPageSidebarLink)`
  background: #fdbe0f;
  color: ${colors.black};
`;
